import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import $ from "jquery";
import StudentReg from './pages/StudentReg';
import StudentList from './pages/StudentList';
import GenerateChallan from './pages/GenerateChallan';
import ChallanStatus from './pages/ChallanStatus';
import Error from "./pages/Error";
import GeneratePDF from './pages/GeneratePDF';
import BoardPending from "./pages/BoardPending";
import BoardApproved from "./pages/BoardApproved";
import ConsolidatedList from "./pages/ConsolidatedList";
import ImprovementChecklist from "./pages/ImprovementChecklist";
import SupplimentaryChecklist from "./pages/SupplimentaryChecklist";
// Admin Part
import AdminLogin from "./admin/login";
import AdminDashboard from "./admin/AdminDashboard";
import PendingVerification from "./admin/PendingVerification";
import ApprovedPayments from "./admin/ApprovedPayments";
import RejectedPayments from "./admin/RejectedPayments";
import PendingSubmission from "./admin/PendingSubmission";
import BoardReports from "./admin/BoardReports";
import CentreLogin from "./admin/CentreLogin";
import UploadNotice from "./admin/UploadNotice";
const App = () => {
  const [studentId, setStudentId] = useState(null);
  const [challanNo, setChallanNo] = useState(null);

   const [improvementCandidateIds, setImprovementCandidateIds] = useState("");
    const [supplementaryCandidateIds, setSupplementaryCandidateIds] = useState("");

  return (
    <Router>
      <TabManager />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/student-registration" element={<StudentReg studentId={studentId} setStudentId={setStudentId} />} />
        <Route path="/student-list" element={<StudentList  studentId={studentId} setStudentId={setStudentId} improvementCandidateIds={improvementCandidateIds} 
        setImprovementCandidateIds={setImprovementCandidateIds} supplementaryCandidateIds={supplementaryCandidateIds} setSupplementaryCandidateIds={setSupplementaryCandidateIds}/>} />
        <Route path="/generate-challan" element={<GenerateChallan challanNo={challanNo} setChallanNo={setChallanNo} />} />
        <Route path="/challan-status" element={<ChallanStatus challanNo={challanNo} setChallanNo={setChallanNo} />} />
        <Route path="/generate-pdf/:challanNo" element={<GeneratePDF />} />
        <Route path="/board-submission-pending" element={<BoardPending />} />
        <Route path="/board-submission-approved" element={<BoardApproved />} />
        <Route path="/consolidated-list" element={<ConsolidatedList />} />


        <Route path="/improvement-checklist" element={<ImprovementChecklist  />} />
        <Route path="/supplimentary-checklist" element={<SupplimentaryChecklist improvementCandidateIds={improvementCandidateIds} 
        setImprovementCandidateIds={setImprovementCandidateIds} supplementaryCandidateIds={supplementaryCandidateIds} setSupplementaryCandidateIds={setSupplementaryCandidateIds}/>} />} />

        {/* Admin Part */}
        <Route path="/Board" element={<AdminLogin />} />
        <Route path="/Board-dashboard" element={<AdminDashboard />} />
        <Route path="/Board-pending-verification" element={<PendingVerification />} />
        <Route path="/Board-approved-payment" element={<ApprovedPayments />} />
        <Route path="/Board-rejected-payment" element={<RejectedPayments />} />
        <Route path="/Board-pending-payment" element={<PendingSubmission />} />
        <Route path="/Board-reports" element={<BoardReports />} />
        <Route path="/centre-login" element={<CentreLogin />} />
        <Route path="/upload-notice" element={<UploadNotice />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
};

const TabManager = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const sessionId = Date.now().toString(); 
  const protectedRoutes = [
    "/dashboard",
    "/student-registration",
    "/student-list",
    "/generate-challan",
    "/challan-status",
    "/board-submission-pending",
    "/board-submission-approved",
    "/Board-dashboard",
    "/Board-pending-verification",
    "/Board-approved-payment",
    "/Board-rejected-payment",
    "/Board-pending-payment",
    "/Board-reports"
  ];

  useEffect(() => {
     if (location.pathname.endsWith(".pdf")) return;
    // Store session ID and route
    localStorage.setItem("sessionId", sessionId);
    localStorage.setItem("currentRoute", location.pathname);

    const logoutUser = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("CentCode");
      localStorage.removeItem("schoolName");
      localStorage.removeItem("sessionId");
      localStorage.removeItem("currentRoute");
      $(".modal-backdrop").remove();
      navigate("/");
    };

    const checkForDuplicateTab = () => {
      const storedSessionId = localStorage.getItem("sessionId");
      const storedRoute = localStorage.getItem("currentRoute");
      if (storedRoute === location.pathname && storedSessionId !== sessionId) {
        logoutUser();
      }
    };

    // Store current route for tracking
    if (protectedRoutes.includes(location.pathname)) {
      localStorage.setItem("currentRoute", location.pathname);
    }

    // Listen for changes from other tabs
    const handleStorageChange = (event) => {
      if (event.key === "currentRoute" || event.key === "sessionId") {
        checkForDuplicateTab();
      }
      if (event.key === "forceLogout" && event.newValue === "true") {
        logoutUser();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      if (protectedRoutes.includes(location.pathname)) {
        localStorage.removeItem("currentRoute"); // Clear route tracking when leaving
      }
    };
  }, [location.pathname, navigate]);

  return null;
};


export default App;
